import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from "../../css/NewsPage.module.css";

const NewsPage = () => {
  const [newsArticles, setNewsArticles] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get('https://techservicemarket-backend.onrender.com/api/users/news');      
      setNewsArticles(response.data);
      setError('');
    } catch (err) {
      console.error('Error fetching news:', err.response?.data || err);
      setError('Failed to fetch news.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <div className={styles.loading}>Loading News...</div>;
  }

  if (error) {
    return <div className={styles.error}>{error}</div>;
  }

  return (
    <div className={styles.newsContainer}>
      <h1>Technology News</h1>
      {newsArticles.map((article) => (
        <div key={article.link} className={styles.articleCard}>
          <div className={styles.articleHeader}>
            <h2>{article.title}</h2>
            <a href={article.link} target="_blank" rel="noopener noreferrer">
              Read More
            </a>
          </div>
          <div className={styles.articleContent}>
            <div className={styles.articleImage}>
              {article.photo_url && <img src={article.photo_url} alt={article.title} />}
            </div>
            <div className={styles.articleDetails}>
              <p className={styles.articleSnippet}>{article.snippet}</p>
              <p className={styles.articleSource}>
                Source: {article.source_name} - Published: {new Date(article.published_datetime_utc).toLocaleDateString()}
              </p>
              <p className={styles.articleAuthors}>
                  Authors: {article.authors.join(', ')}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NewsPage;